export default __webpack_public_path__ + "static/media/3_3.40aff67a.jpg";